/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    parts: ['popper', 'content', 'body'],
    baseStyle: {
        popper: {
            borderColor: 'transparent',
            borderRadius: 'base',
            boxShadow: '0px 1px 12px rgba(0, 0, 0, 0.25)'
        }
    },
    variants: {
        small: {
            popper: {
                boxShadow: 'none'
            }
        },
        normal: {
            popper: {
                width: 286
            },
            header: {
                textAlign: 'left',
                fontWeight: 700,
                borderBottom: 'none',
                fontSize: 18,
                px: 7,
                paddingTop: 6
            },
            footer: {
                textAlign: 'left',
                fontSize: 14,
                px: 3,
                borderTop: 'none'
            },
            content: {
                width: 286
            },
            body: {
                py: 0
            }
        },
        fullWidth: {
            popper: {
                width: '100%',
                maxWidth: '100%',
                boxShadow: 'none',
                top: '0',
                right: 'auto',
                bottom: 'auto',
                left: '0'
            },
            content: {
                width: 'auto'
            }
        },
        sort: {
            popper: {
                width: 'auto',
                background: 'linear-gradient(117deg, #FFF 9.91%, #FFF 97.33%)',
                boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.10)'
            },
            content: {
                width: 'auto',
                borderRadius: 0
            },
            body: {
                p: 0
            }
        }
    },
    defaultProps: {
        variant: 'normal'
    }
}
